<template>
    <div>
        <v-card :style="cardStyle" id="tutorialCard" outlined color="primary" v-if="displayOverlay">
            <v-row v-if="texts[currentTextStep].img && texts[currentTextStep].outed" class="g-0">
                <v-col cols="1"> </v-col>
                <v-col cols="10" class="d-flex justify-center">
                    <v-img
                        :src="texts[currentTextStep].img"
                        style="width: 170px; margin-top: -50px"
                    />
                </v-col>
                <v-col cols="1" class="d-flex justify-center">
                    <v-btn icon="mdi-close" size="small" @click="closeOverlay" />
                </v-col>
            </v-row>
            <v-img
                v-else-if="texts[currentTextStep].img"
                width="310"
                :src="texts[currentTextStep].img"
                class="d-flex justify-end"
            >
                <v-spacer />
                <v-btn icon="mdi-close" size="small" @click="closeOverlay" />
            </v-img>
            <v-card-text class="ma-0 pa-0" color="primary">
                <v-list color="primary">
                    <v-list-item class="oss-list-item" color="primary">
                        <v-row no-gutters>
                            <v-col
                                cols="11"
                                class="font-weight-bold d-flex align-center subtitle-1"
                            >
                                {{ title }}
                            </v-col>
                            <v-col cols="1" v-if="!texts[currentTextStep].img">
                                <v-btn icon="mdi-close" size="small" @click="closeOverlay" />
                            </v-col>
                            <!-- <v-col cols="12" v-if="texts[currentTextStep].video">
                                <vue-plyr>
                                    <video
                                        controls
                                        :crossorigin="true"
                                        playsinline
                                    >
                                        <source
                                            size="720"
                                            :src="texts[currentTextStep].video"
                                            type="video/mp4"
                                        />
                                    </video>
                                </vue-plyr>
                            </v-col> -->
                            <v-col cols="12" class="body-1">
                                {{ texts[currentTextStep].text }}
                            </v-col>
                            <v-col cols="12" class="d-flex justify-center align-center">
                                <v-btn-prev
                                    @click="previousStep"
                                    :disabled="disabledPevious"
                                    size="small"
                                />
                                <span class="px-4">
                                    {{ currentTutorialStep }}/{{ totalSteps }}
                                </span>
                                <v-btn-next @click="nextStep" size="small" />
                            </v-col>
                        </v-row>
                    </v-list-item>
                </v-list>
            </v-card-text>
        </v-card>
        <v-overlay
            :absolute="displayOverlay"
            :z-index="1000"
            class="oss-overlay"
            :style="overlayStyle"
            id="tuto-overlay"
            v-model="displayOverlay"
        />
    </div>
</template>

<script lang="ts">
import emitter from "@/services/emitter";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class Tutorial extends Vue {
    steps = [];
    stepDisplayed = 0;
    displayTutorial = true;
    style = "";
    currentTextStep = 0;
    currentTutorialStep = 1;
    tutoCalculationInDialog: any = null;

    // cardStyle = ""

    offset = {
        top: 0,
        left: 0,
    };

    get displayOverlay() {
        if (this?.steps?.length && this.displayTutorial) {
            return true;
        }
        return false;
    }

    get ref() {
        // debugger

        if (this.tutoCalculationInDialog) {
            return this.tutoCalculationInDialog;
        }
        if (this.steps[this.stepDisplayed] && this.steps[this.stepDisplayed].ref) {
            return this.steps[this.stepDisplayed].ref;
        }
        return null;
    }

    get totalSteps() {
        return this.steps.flatMap((x) => x.pages).length;
    }

    get title() {
        return this.steps[this.stepDisplayed].title;
    }

    get texts() {
        return this.steps[this.stepDisplayed].pages;
    }

    get overlayStyle() {
        return {
            "align-items": !!this.ref ? "center" : undefined,
            "justify-content": !!this.ref ? "center" : undefined,
        };
        // return this.ref ? "" : "align-items: center; justify-content: center;"
    }

    calcOffset() {
        // debugger
        if (this.stepDisplayed >= 0 && this.stepDisplayed < this.steps.length) {
            const el = this.steps[this.stepDisplayed]?.ref || null;
            if (el) {
                const rect = el.getBoundingClientRect();
                const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                this.offset.top = rect.top + scrollTop;
                this.offset.left = rect.left + scrollLeft;
            } else {
                // debugger
            }
        }
    }

    get cardStyle() {
        const tutorialCard = document.getElementById("tutorialCard");
        const style = {
            "z-index": 1002,
            "max-width": "310px",
            position: "absolute",
            left: undefined,
            top: undefined,
        };
        // this.cardStyle = style

        // Uniquement pour les dialogues
        if (this.texts[this.currentTextStep].isDialog === true) {
            this.beforeDisplay();
        }
        if (this.texts[this.currentTextStep].isDialog === true) {
            this.beforeDisplay();
        }
        if (this.ref) {
            // await this.$forceUpdate()
            const cardDimention = {
                height: tutorialCard?.offsetHeight || 0,
                width: tutorialCard?.offsetWidth || 0,
            };

            const refDimention = {
                height: this.ref.offsetHeight,
                width: this.ref.offsetWidth,
            };
            // --- ALIGN START ---
            if (
                !this.texts[this.currentTextStep].align ||
                this.texts[this.currentTextStep].align === "start"
            ) {
                if (this.texts[this.currentTextStep].position === "left") {
                    style.left = +(this.offset.left - cardDimention.width - 10) + "px";
                    style.top = this.offset.top + "px";
                } else if (this.texts[this.currentTextStep].position === "bottom") {
                    style.left = this.offset.left + "px";
                    style.top = this.offset.top + refDimention.height + 10 + "px";
                    // // debugger
                } else if (this.texts[this.currentTextStep].position === "right") {
                    style.left = +(this.offset.left + refDimention.width + 10) + "px";
                    style.top = +this.offset.top + "px";
                } else if (this.texts[this.currentTextStep].position === "top") {
                    // // debugger
                    style.left = this.offset.left + "px";
                    style.top = Math.max(this.offset.top - cardDimention.height - 10, 5) + "px";
                }
            }
            // --- ALIGN CENTER ---
            else if (this.texts[this.currentTextStep].align === "center") {
                // debugger
                if (this.texts[this.currentTextStep].position === "left") {
                    style.left = this.offset.left - cardDimention.width - 10 + "px";
                    style.top =
                        this.offset.top + refDimention.height / 2 - cardDimention.height / 2 + "px";
                    console.log("LEFT ::::", this.offset.left - cardDimention.width - 10);
                    console.log(
                        "TOP ::::",
                        this.offset.top + refDimention.height / 2 - cardDimention.height / 2,
                    );
                } else if (this.texts[this.currentTextStep].position === "bottom") {
                    style.left =
                        this.offset.left + refDimention.width / 2 - cardDimention.width / 2 + "px";
                    style.top = this.offset.top + refDimention.height + 10 + "px";
                    // // debugger
                } else if (this.texts[this.currentTextStep].position === "right") {
                    style.left = this.offset.left + refDimention.width + 10 + "px";
                    style.top =
                        this.offset.top + refDimention.height / 2 - cardDimention.height / 2 + "px";
                } else if (this.texts[this.currentTextStep].position === "top") {
                    // debugger
                    style.left =
                        this.offset.left + refDimention.width / 2 - cardDimention.width / 2 + "px";
                    style.top = Math.max(this.offset.top - cardDimention.height - 10, 5) + "px";
                }
            }
            // --- ALIGN END ---
            else if (this.texts[this.currentTextStep].align === "end") {
                if (this.texts[this.currentTextStep].position === "left") {
                    style.left = this.offset.left - cardDimention.width - 10 + "px";
                    style.top = this.offset.top + refDimention.height - cardDimention.height + "px";
                } else if (this.texts[this.currentTextStep].position === "bottom") {
                    style.left = this.offset.left + refDimention.width - cardDimention.width + "px";
                    style.top = this.offset.top + refDimention.height + 10 + "px";
                    // debugger
                } else if (this.texts[this.currentTextStep].position === "right") {
                    style.left = this.offset.left + refDimention.width + 10 + "px";
                    style.top = this.offset.top + refDimention.height - cardDimention.height + "px";
                } else if (this.texts[this.currentTextStep].position === "top") {
                    // debugger
                    style.left = this.offset.left + refDimention.width - cardDimention.width + "px";
                    style.top = Math.max(this.offset.top - cardDimention.height - 10, 5) + "px";
                }
            }
            // console.log("tutorialCard Style", style)

            style.top = `calc(${style.top} + ${this.haveOutedImage ? "120px" : "0px"})`;
            return style;
        } else {
            const style = {
                "z-index": 1002,
                "max-width": "310px",
                position: "absolute",
                // "top": "250px",
                // "left": "814px",
                top: "28%",
                left: "43%",
            };
            style.top = `calc(${style.top} + ${this.haveOutedImage ? "120px" : "0px"})`;
            return style;
        }
    }

    get haveOutedImage() {
        return this.texts[this.currentTextStep].img && this.texts[this.currentTextStep].outed;
    }

    get disabledPevious() {
        return this.stepDisplayed === 0 && this.currentTextStep === 0;
    }

    onKeyDown(event) {
        if (event) {
            const keyCode = event.keyCode || event.which;
            if (keyCode) {
                if (keyCode === 37) {
                    this.previousStep();
                } else if (keyCode === 27) {
                    this.closeOverlay();
                } else {
                    // if ( this.texts[this.currentTextStep].isDialog === true && this.tutoCalculationInDialog) {
                    //     this.tutoCalculationInDialog.remove()
                    //     this.tutoCalculationInDialog = null
                    // }
                    this.nextStep();
                }
            }
        }
    }

    beforeMount() {
        emitter.$on("setTutorialData", (data) => this.setData(data));
    }

    setData(data) {
        this.steps = data;
        this.stepDisplayed = 0;
        this.currentTextStep = 0;
        this.currentTutorialStep = 1;
        this.displayTutorial = true;
        this.displayStep();
        // this.calculCardStyle()
        this.beforeDisplay();

        if (this.stepDisplayed >= 0 && this.stepDisplayed < this.steps.length) {
            window.addEventListener("resize", this.calcOffset);
        }
        document.addEventListener("keydown", this.onKeyDown);
    }

    async nextStep() {
        debugger;
        if (this.currentTextStep < this.texts.length - 1) {
            this.currentTextStep++;
        } else if (this.currentTextStep >= this.texts.length - 1) {
            this.currentTextStep = 0;

            if (this.texts[this.currentTextStep].isDialog === true) {
                this.removecalcOffSetInADialog();
            }
            if (this.ref.classList) {
                this.ref.classList.remove("oss-hight-light");
            } else {
                debugger; // TO DEBUG
            }
            if (this.stepDisplayed < this.steps.length - 1) {
                this.stepDisplayed++;
                await this.displayStep();
            } else {
                this.closeOverlay();
            }
        }
        this.currentTutorialStep++;

        // this.calculCardStyle()
    }

    async previousStep() {
        debugger;
        if (this.disabledPevious) {
            return;
        }
        if (this.currentTextStep > 0) {
            this.currentTextStep--;
        } else if (this.currentTextStep <= 0) {
            if (this.stepDisplayed > 0) {
                if (this.ref?.classList) {
                    this.ref.classList.remove("oss-hight-light");
                } else {
                    debugger; // TO DEBUG
                }
                if (this.texts[this.currentTextStep].isDialog === true) {
                    this.removecalcOffSetInADialog();
                    if (this.stepDisplayed === 1) {
                        this.closeDialog();
                    }
                }
                this.stepDisplayed--;
                this.currentTextStep = this.texts.length - 1;
                await this.displayStep();
            }
        }

        this.currentTutorialStep--;
        // this.calculCardStyle()
    }

    async displayStep() {
        await this.beforeDisplay();
        if (this.ref?.classList) {
            this.ref.classList.add("oss-hight-light");
        } else {
            debugger; // TO DEBUG
        }
        this.calcOffset();
    }

    closeOverlay() {
        if (this.ref?.classList) {
            this.ref.classList.remove("oss-hight-light");
        } else {
            debugger; // TO DEBUG
        }
        document.removeEventListener("keydown", this.onKeyDown);
        window.removeEventListener("resize", this.calcOffset);
        this.steps = [];
        this.displayTutorial = false;
    }

    closeDialog() {
        document.getElementById("BtnCloseDialog").click();
    }

    calcOffSetInADialog(elementId) {
        const recettesButton = document.getElementById(elementId);
        if (!recettesButton) {
            return;
        }
        const overlay = document.getElementById("tuto-overlay");
        const height = recettesButton.getBoundingClientRect().height;
        const width = recettesButton.getBoundingClientRect().width;
        const newrecettesButton = recettesButton.cloneNode(true) as HTMLElement;

        this.tutoCalculationInDialog = overlay.appendChild(newrecettesButton);
        this.tutoCalculationInDialog.style.height = height + "px";
        this.tutoCalculationInDialog.style.width = width + "px";
        this.tutoCalculationInDialog.style.position = "absolute";
        this.tutoCalculationInDialog.style.top = recettesButton.getBoundingClientRect().top + "px";
        this.tutoCalculationInDialog.style.left =
            recettesButton.getBoundingClientRect().left + "px";
        this.calcOffset();
    }

    removecalcOffSetInADialog() {
        debugger;
        this.tutoCalculationInDialog.remove();
        this.tutoCalculationInDialog = null;
    }

    async beforeDisplay() {
        if (this.texts[this.currentTextStep]?.before) {
            if (this.texts[this.currentTextStep].before?.clicks?.length) {
                for (const c of this.texts[this.currentTextStep].before.clicks) {
                    document.getElementById(c).click();

                    // let idInDiv = this.ref.getElementsByTagName("div");
                    // var id = idInDiv[c].id;
                    // console.log("div", id)

                    setTimeout(() => {
                        if (this.texts[this.currentTextStep].isDialog === true) {
                            this.calcOffSetInADialog(this.texts[this.currentTextStep].ref);
                        }
                    }, 330);

                    // if ( this.texts[this.currentTextStep].isDialog === true) {
                    //     await this.removecalcOffSetInADialog()
                    // }
                }
            }
        }
        return;
    }
}

export default toNative(Tutorial);
</script>

<style scoped>
.oss-overlay {
    align-items: unset;
    justify-content: flex-start;
}
</style>
